module.exports = __webpack_public_path__ + "static/Jason-0588a88b955ba5fd22419e562d6231e9.jpg";